module.exports = __webpack_public_path__ + "static/media/donbosco11.fb7d9fc3.jpg";